import { Component, OnInit, Input, Output } from '@angular/core';
import { TimeWorker } from '../../../../../../common/utils/timeWorker';

@Component({
  selector: 'app-chat-content',
  templateUrl: './chat-content.component.html',
  styleUrls: ['./chat-content.component.css'],
})
export class ChatContentComponent implements OnInit {
  @Input() messages: any = [];

  protected image_agent = 'assets/images/agent.jpg';
  protected image_contact = 'assets/images/contact.png';
  protected no_image = 'assets/images/contact.png';

  protected readonly TimeWorker = TimeWorker;

  constructor() {
    this.messages = this.messages.filter(m => m);
  }

  ngOnInit() {}

  isSingleLink(content: string): boolean {
    const urlPattern = /^https?:\/\/\S+$/;
    return urlPattern.test(content);
  }

  formatContent(message: any): string {
    const content = message.content;
    const className = message.chatter_type == 'agent' ? 'text-white text-right' : 'text-primary text-left';
    const urlPattern = /https?:\/\/\S+/g;
    return content.replace(urlPattern, url => {
      if (/\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(url)) {
        return `<img src="${url}" class="${className}" style="max-width: 100%; height: auto; border-radius: 5px" alt="Image"><br>`;
      } else {
        return `<a href="${url}" target="_blank" class="${className}">${url}</a><br>`;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/chat/chat-box/chat-content/chat-content.component.ts